import fetch from '@/util/fetch';
import {baseUrl1, baseUrl2} from '@/global';

export const login = (params) => fetch.post(`${baseUrl1}/oauth/token`, params.payload,
    {
      params: {
        grant_type: 'password',
        client_id: 'web',
        client_secret: '123456',
        validCode: 'hbcs',
        ...params,
      },
      isIgnoreToken: true,
    },
);

/**
 * 获取用户信息
 */
export const getUserInfo = () => fetch(`${baseUrl2}/user-center/user/info`);

/**
 * 修改用户信息
 */
export const editUserInfo = (data) => fetch.put(`${baseUrl2}/user-center/user/edit`, data);

/**
 * 修改密码
 */
export const retrievePwd = (data) => fetch.post(`${baseUrl2}/user-center/user/retrievePwd`, data);

/**
 * 修改手机号码
 */
export const updateMobile = (params) => fetch.put(`${baseUrl2}/user-center/user/updateMobile`, params.payload, {params});

/**
 * 修改手机号验证
 */
export const updateMobileVerify = (params) => fetch(`${baseUrl2}/user-center/user/updateMobileVerify`, {params: {identityType: 2, ...params}});

/**
 * 修改密码身份验证
 */
export const updatePasswordVerify = (params) => fetch(`${baseUrl2}/user-center/user/verify`, {params});

/**
 * 图形验证码发送接口
 */
export const captchaImageUrl = `${baseUrl2}/captcha/image?deviceId=`;
/**
 * 登入是否弹出验证
 */
export const loginCaptchaRequired = (params) => fetch(`${baseUrl1}/oauth/loginCaptchaRequired`, {params, isIgnoreToken: true});
/**
 * 图形验证码发送接口-滑动
 */
export const captchaBlockPuzzle = (params) => fetch.post(`${baseUrl2}/captcha/blockPuzzle?deviceId=${params.deviceId}`);
/**
 * 图形验证接口-滑动校验
 */
export const blockPuzzleCheck = (params) => fetch.post(`${baseUrl2}/captcha/blockPuzzleCheck?deviceId=${params.deviceId}&pointJson=${params.pointJson}&token=${params.token}`);

/**
 * 短信验证码发送接口
 */
export const captchaSmsCode = (params) => fetch.get(`${baseUrl2}/captcha/sms?imageCaptcha=${params.captchaVerification || params.imageCaptcha}&mobile=${params.mobile}&deviceId=${params.deviceId}&senderId=${params.senderId || '3'}`);
export const captchaSms = (params) => fetch.post(`${baseUrl2}/captcha/sms2?captchaVerification=${params.captchaVerification || params.imageCaptcha}&mobile=${params.mobile}&deviceId=${params.deviceId}&senderId=${params.senderId || '3'}`);

/**
 * 图片文件上传接口
 */
// export const imgUpload = (params) => fetch.post(`${baseUrl2}/file-center/file/uploadAvatar`, params);
export const imgUpload = (params) => fetch.post(`${baseUrl2}/zuul/file-center/file/uploadImg`, params);

/**
 * 设置默认企业
 */
export const setDefaultCorp = (params) => fetch.put(`${baseUrl2}/user-center/user/defaultCorp/${params.corpId}`);

/**
 * 忘记密码
 */
export const forgotPwd = (params) => fetch.post(`${baseUrl2}/user-center/user/forgetPwd`, params.payload, {params});
